module.exports = __webpack_public_path__ + "img/voice.7b14279c.svg";